module.exports = __webpack_public_path__ + "img/kbeauty-5.4720331a.svg";